import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../common/Table';
import { CABIN_CREW_MOVEMENT_HISTORY_PATH } from '../../../../../config/paths';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { CABIN_CREW_MOVEMENT_HISTORY_COLUMNS } from '../../../../../config/columns';

const CabinCrewMovementsHistoryBasicResource = ({ cabinCrewMovementHistoryList }) => (
  <>
    <hr />
    <h2>Historial de Movimientos</h2>
    <Table
      columns={CABIN_CREW_MOVEMENT_HISTORY_COLUMNS}
      data={cabinCrewMovementHistoryList}
      modelPath={CABIN_CREW_MOVEMENT_HISTORY_PATH}
      manual={false}
      filterable
      defaultFilterMethod={filterMethodCaseInsensitive}
      navigateToModelOnRowClick
      openPathInNewTab
    />
  </>
);

CabinCrewMovementsHistoryBasicResource.propTypes = {
  cabinCrewMovementHistoryList: PropTypes.arrayOf(
    PropTypes.shape({
      cabinCrewMovementId: PropTypes.number.isRequired,
      cabinCrewMovementName: PropTypes.string.isRequired,
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default CabinCrewMovementsHistoryBasicResource;
